// extracted by mini-css-extract-plugin
export default {"toolbarButton":"ToolbarButton_toolbarButton__UL0Jb"};